import React from 'react';

import { getUserProfileUrl } from '@adsk/acs-sc-web-platform-api';
import A from '@adsk/alloy-react-a';
import { Flex, Text } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

export const MFATooltipContent = () => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <Flex flexDirection="column">
      <Text typography="heading5">{T.translate('MFA_REQUIRED')}</Text>
      <Text>
        {T.translate(
          'TWO_STEPS_VERIFICATION_IS_REQUIRED_TO_ACCESS_THIS_PROJECT',
        )}
      </Text>
      <Divider
        style={{
          marginTop: theme.spacing.medium,
          marginBottom: theme.spacing.small,
        }}
      />
      <A
        style={{ color: theme.colors.adskBlue100 }}
        href={`${getUserProfileUrl()}/security`}
        onClick={(e) => e.stopPropagation()}
      >
        {T.translate('SETUP_TWO_STEPS_VERIFICATION')}
      </A>
    </Flex>
  );
};
